
import requests from "./api/api";

const LoginService = {

   
    sentOtp:(body)=>requests.post('/user/v1/send-otp',body),
    submitOtp:(body)=>requests.post('/user/v1/submit-otp',body),
    submitInfo:(body)=>requests.put('/user/v1/register-base-user',body),

};

export default LoginService;